import {
  EditorialCalloutBlock,
  EditorialClosingBlock,
  EditorialPanel,
  EditorialSideBySideBlock,
} from "../editorial";

/**
 * Detalles · paso 4 · Con qué se cierra.
 *
 * La comparación (dos lados enfrentados), la nota destacada y la frase
 * final. Los tres son el último tramo de la página: lo que se lee justo
 * antes de decidir.
 */
export function ClosingStep() {
  return (
    <EditorialPanel
      title="Cierre"
      description="El último tramo de la ficha, justo antes de decidir. Ninguno es obligatorio."
    >
      {(locale) => (
        <>
          <EditorialSideBySideBlock locale={locale} />
          <EditorialCalloutBlock locale={locale} />
          <EditorialClosingBlock locale={locale} />
        </>
      )}
    </EditorialPanel>
  );
}
